import { render, staticRenderFns } from "./questionDialog.vue?vue&type=template&id=3f535c10&scoped=true"
import script from "./questionDialog.vue?vue&type=script&lang=js"
export * from "./questionDialog.vue?vue&type=script&lang=js"
import style0 from "./questionDialog.vue?vue&type=style&index=0&id=3f535c10&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f535c10",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/gkzy/Desktop/achievement-transform-system/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3f535c10')) {
      api.createRecord('3f535c10', component.options)
    } else {
      api.reload('3f535c10', component.options)
    }
    module.hot.accept("./questionDialog.vue?vue&type=template&id=3f535c10&scoped=true", function () {
      api.rerender('3f535c10', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/resultsAnalysis/comps/questionDialog.vue"
export default component.exports